/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiDatumTarget = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.252 17.047V6.87h3.234c1.652 0 2.898.43 3.738 1.288.85.859 1.274 2.128 1.274 3.808 0 1.67-.425 2.935-1.274 3.794-.84.859-2.086 1.288-3.738 1.288H5.252zm3.206-8.736H7.002v7.294h1.456c1.083 0 1.89-.299 2.422-.896.541-.597.812-1.512.812-2.744 0-1.232-.266-2.147-.798-2.744-.532-.607-1.344-.91-2.436-.91zm6.916 6.342v-3.64H14.1v-.854l1.316-.504.574-2.044h1.092v2.072h1.582v1.33h-1.582v3.626c0 .392.089.677.266.854.177.168.439.252.784.252h.322c.121-.01.22-.018.294-.028v1.344c-.187.028-.36.047-.518.056-.15.01-.317.014-.504.014-.793 0-1.386-.2-1.778-.602-.383-.401-.574-1.027-.574-1.876z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiDatumTarget as PmiDatumTarget };
